import { createResourceContentSelector } from 'util/selector/resourceSelector';

import { createSelector } from '@reduxjs/toolkit';
import { AdminState } from 'reduxStore/appStore';
import { CompanyState } from 'reduxStore/company/initialState';

export const selectDomain = (state: AdminState) => state.company as CompanyState.Domain;

export const selectCompanyListResource = createSelector(
  selectDomain,
  (domain) => domain.listResource,
);

export const selectCompanyProjectListResource = createSelector(
  selectDomain,
  (domain) => domain.projectListResource,
);

export const selectCompanyList = createResourceContentSelector(selectCompanyListResource);

export const selectCompanyProjectList = createResourceContentSelector(
  selectCompanyProjectListResource,
);

export const selectMergeConnectionsResource = createSelector(
  selectDomain,
  (domain) => domain.mergeConnectionsResource,
);

export const selectMergeConnections = createResourceContentSelector(selectMergeConnectionsResource);

export const selectHasActiveMergeConnection = createSelector(
  selectMergeConnections,
  (connections) => (connections?.length ?? 0) > 0,
);
